import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { NOJOOM_STATUS_COLORS, SELECTED_LANG } from '../../services/common/Constants';
import MessageModal from '../common/bottom-modal-message';
import { getItemOfSessionStorage } from '../../services/common/utils';
const hrCss = {
  RED: 'hr_red',
  SILVER: 'hr_grey',
  GOLD: 'hr_silver',
  NOKHBA: 'hr_black',
};

const NojoomDashboardStats = ({ data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const lang = getItemOfSessionStorage(SELECTED_LANG);

  const mSISDNIdInfo =
    data?.response?.ListOfMSISDNLoyMember?.length > 0
      ? data?.response?.ListOfMSISDNLoyMember[0]
      : null;

  const toggleMessageModal = () => {
    setShowModal(!showModal);
  };
  const status = mSISDNIdInfo?.TierLevel?.toUpperCase();
  return (
    <>
      {/* <div>
        {mSISDNIdInfo?.PrimaryMSISDNId === 'N' && (
          <div className="nojoom_points_overview nojoom_points_top_card">
            <div className="d-flex justify-content-between mb-4">
              <img
                src={process.env.PUBLIC_URL + '/assets/images/info_red.svg'}
                alt=""
                title=""
              />
              <label className="ms-3">
                {data?.response?.Messages['62009'] || ''}
              </label>
            </div>
          </div>
        )}

        <div
          className="nojoom_points_overview mb-4 -mt-24 nojoom_points_bg"
          style={{
            backgroundColor:
              NOJOOM_STATUS_COLORS[mSISDNIdInfo?.TierLevel?.toUpperCase()],
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <label>{t('availpoints')}</label>
              <h5 className="mt-1 mb-0">{mSISDNIdInfo?.RewardPoints || ''}</h5>
            </div>
            <div className="z-3">
              <button className="custom_btn custom_btn_primary_outline custom_btn_primary_outline_bgn btn_block me-2">
                {t('buypoints')}
              </button>
            </div>
          </div>
          <hr className="hr_red" />
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <label>{t('memberpoints')}</label>
              <h5 className="mt-1 mb-0">{mSISDNIdInfo?.MemberNumber || ''}</h5>
            </div>
            <div className="d-flex flex-column flex29">
              <div className="d-flex align-items-center">
                <label>{t('star')}</label>
                <img
                  src={process.env.PUBLIC_URL + '/assets/images/help_sm.svg'}
                  alt=""
                  title=""
                  className="ms-1"
                />
              </div>
              <h5 className="mt-1 mb-0">{mSISDNIdInfo?.CurrentStar}</h5>
            </div>
          </div>
          <hr className="hr_red" />
          <div className="z-3">
            <button className="custom_btn custom_btn_primary_outline btn_block" onClick={() => navigate("/nojoom-manage")}>
              {t('manage')}
            </button>
          </div>

          <div className="nojoom_bg_img" onClick={toggleMessageModal}>
            <img
              src={process.env.PUBLIC_URL + '/assets/images/star-bg.png'}
              alt=""
              title=""
            />
          </div>
        </div>
      </div> */}

      <div className="nojoom_points_bg">
        {mSISDNIdInfo?.PrimaryMSISDNId === 'N' && (
          <div className="nojoom_points_overview nojoom_points_top_card">
            <div className="d-flex mb-4">
              <img
                src={process.env.PUBLIC_URL + '/assets/images/info_red.svg'}
                alt=""
                title=""
              />
              <label className="ms-3">
                {data?.response?.Messages['62009'] || ''}
              </label>
            </div>
          </div>
        )}

        <div className={`nojoom_points_overview mb-4 -mt-24 ${mSISDNIdInfo?.PrimaryMSISDNId !== 'N' ? 'mt-3' : ''}`} style={{
            backgroundColor:
              NOJOOM_STATUS_COLORS[mSISDNIdInfo?.TierLevel?.toUpperCase()],
          }}>
          <div className="d-flex justify-content-between align-items-center z-3">
            <div>
              <label>{t('availpoints')}</label>
              <h5 className="mt-1 mb-0">{mSISDNIdInfo?.RewardPoints || ''}</h5>
            </div>
            {/* <div className="z-3">
              <a href='#/nojoom-buypoints' 
              // className='custom_btn btn_block me-2 custom_btn_primary_outline custom_btn_primary_outline_bgn'
              className='custom_btn btn_block me-2'
              style={{
                  color: '#fff',
              }}
              >

              {t('buypoints')}
              </a>
            </div> */}
          </div>
          <hr className={`${hrCss[status]}`} />
          <div className="d-flex align-items-center justify-content-between z-3">
            <div>
              <label>{t('memberpoints')}</label>
              <h5 className="mt-1 mb-0">{mSISDNIdInfo?.MemberNumber || ''}</h5>
            </div>
            <div className="d-flex flex-column flex29" onClick={() => toggleMessageModal()}>
              <div className="d-flex align-items-center">
                <label>{t('star')}</label>
                <img
                  src={process.env.PUBLIC_URL + '/assets/images/help_sm.svg'}
                  alt=""
                  title=""
                  className={`ms-1 cursor ${lang === 'ar' ? 'flipimg' : ''}`}
                />
              </div>
              <h5 className="mt-1 mb-0">{mSISDNIdInfo?.CurrentStar || ''}</h5>
            </div>
          </div>
          <hr className={`${hrCss[status]}`} />
          <div className="d-flex justify-content-between">
            <div className="z-3">
                <a href='#/nojoom-buypoints' 
                // className='custom_btn btn_block me-2 custom_btn_primary_outline custom_btn_primary_outline_bgn'
                  className='custom_btn btn_block me-2'
                  style={{color: '#fff'}}
                >
                {t('buypoints')}
                </a>
            </div>
            <div className="z-3">
            
              <a onClick={() => navigate("/nojoom-manage")} 
              // className="custom_btn btn_block custom_btn_primary_outline"
              className="custom_btn btn_block me-2"
              style={{color: '#fff'}}
              >
              {t('manage')}
              </a>
            </div>
          </div>
          <div className="nojoom_bg_img">
            <img
              src={process.env.PUBLIC_URL + '/assets/images/star-bg.png'}
              alt=""
              title=""
              onClick={toggleMessageModal}
            />
          </div>
        </div>
      </div>

      <MessageModal
        show={showModal}
        toggleModal={toggleMessageModal}
        title={data?.response?.starpopup?.title}
        message={data?.response?.starpopup?.description}
      />
    </>
  );
};

export default NojoomDashboardStats;
